import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DataVisualizationPopupState } from '@core/models/data-visualization/data-visualization.model';

export const selectorDataVisualizationPopup =
  createFeatureSelector<DataVisualizationPopupState>('dataVisualizationPopup');

export const selectIsPopupOpen = createSelector(
  selectorDataVisualizationPopup,
  (state: DataVisualizationPopupState) => state.isOpen
);

export const selectActiveVisualizationModules = createSelector(
  selectorDataVisualizationPopup,
  (state: DataVisualizationPopupState) => state.activeVisualizationModules
);

export const selectIsFilteringEnabled = createSelector(
  selectorDataVisualizationPopup,
  (state: DataVisualizationPopupState) => state.isFilteringEnabled
);

/** True in the data-visualization popup window itself, as opposed to the main window. */
export const selectIsPopupWindow = createSelector(
  selectorDataVisualizationPopup,
  (state: DataVisualizationPopupState) => state.isPopup
);
